import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 20px;
  }
  @media (min-width: 570px) {
    flex-direction: row;
  }
`;

export const Form = styled.form`
  width: 100%;
  & > * {
    display: block !important;
    margin-bottom: 10px !important;
  }
  @media (min-width: 570px) {
    margin-left: 20px;
  }
`;

export const ProductImageContainer = styled.div`
  position: relative;
  & > p {
    font-size: 15px;
    text-align: center;
  }
  & .dropzone {
    width: 100%;
    height: auto;
    @media (min-width: 426px) {
      width: 300px;
      height: 200px;
    }
  }
`;

export const CenterBlock = styled.div`
  text-align: center;
  padding-top: 10px;
`;

export const Actions = styled.div`
  display: flex;
  margin-top: 20px;
  & > button {
    margin-right: 20px;
  }
`;
